export default "__VITE_ASSET___VoaZkTY__"